import { Asterisk } from "lucide-react";
import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = t.marquee;

  const Row = ({ hidden = false }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {items.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-display text-lg font-extrabold uppercase tracking-wide sm:text-xl">
            {item}
          </span>
          <Asterisk size={22} className="shrink-0" strokeWidth={2.5} />
        </span>
      ))}
    </div>
  );

  return (
    <div className="relative z-20 -my-3 overflow-hidden py-5">
      <div className="-mx-4 -rotate-1 border-y-2 border-black bg-accent py-4 text-black shadow-[0_0_50px_rgba(255,0,122,0.35)]">
        <div className="marquee-track flex w-max animate-marquee">
          <Row />
          <Row hidden />
        </div>
      </div>
    </div>
  );
}
